export default {"src":"/_next/static/media/Apache.4067fbb9.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};